import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { createDefaultHours, CreateDefaultHoursPayload, defaultHoursCreated, defaultHoursCreationFailed } from '@/store/actions/setting/createDefaultHours';

import { fromDto as hoursFromDto } from '../../../models/adapters/HoursAdapter';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* createDefaultHoursSaga({ payload }: Action<CreateDefaultHoursPayload>) {
  const { placeUuid } = payload;
  const token = yield getAuthenticationToken();
  const { error, hoursDto } = yield getProtectedResponse(ProtectedServerPlaceEvent.createDefaultHours, token, { placeUuid });
  if (!error) {
    yield put(defaultHoursCreated({ hours: hoursFromDto(hoursDto) }));
  } else {
    yield put(defaultHoursCreationFailed({ placeUuid }));
  }
}

export default function* watchCreateDefaultHoursSaga() {
  yield takeEvery(createDefaultHours, createDefaultHoursSaga);
}
